import { jsx as s } from "react/jsx-runtime";
function n(r) {
  const {
    className: o,
    children: t,
    ...e
  } = r;
  return /* @__PURE__ */ s(
    "tr",
    {
      className: o,
      ...e,
      children: t
    }
  );
}
export {
  n as default
};
